module.exports = __webpack_public_path__ + "static/img/bird1.8740eb8.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bird1.gif
// module id = Jtrz
// module chunks = 1